import clsx from 'clsx';
import { ReactNode } from 'react';

export const Section = ({
  children,
  className,
  id,
}: {
  children: ReactNode;
  className?: string;
  id?: string;
}) => {
  return (
    <section id={id} className={clsx('section', className)}>
      {children}
    </section>
  );
};
